// Example React component for Check-In/Check-Out
// filepath: src/components/CheckInOut.js
import React, { useState, useEffect } from 'react';
import { volassisAPI } from '../services/api';

const CheckInOut = ({ userId, orgId, initialStatus, onStatusChange }) => {
  const [status, setStatus] = useState(initialStatus || 'Checked Out');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  // Fetch current status on mount (optional, if not passed as prop)
  useEffect(() => {
    if (!initialStatus) {
      volassisAPI.getCheckInDisable(userId, orgId)
        .then(res => setStatus(res.status))
        .catch(() => setStatus('Checked Out'));
    }
  }, [userId, orgId, initialStatus]);

  const handleCheckInOut = async () => {
    setLoading(true);
    setMessage('');
    try {
      const result = await volassisAPI.checkInCheckOut(userId, orgId);
      setStatus(result.status);
      setMessage(result.message || 'Status updated!');
      if (onStatusChange) onStatusChange(result.status);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Error updating status.');
    }
    setLoading(false);
  };

  return (
    <div>
      <div>
        <strong>Status:</strong> {status}
      </div>
      <div style={{ color: message.includes('Error') ? 'red' : 'green' }}>{message}</div>
    </div>
  );
};

export default CheckInOut;